module.exports = __webpack_public_path__ + "img/radiate.1d02344e.svg";